import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth.jsx";
import Login from "./pages/Login.jsx";
import Layout from "./components/Layout.jsx";
import Overview from "./pages/Overview.jsx";
import Attempts from "./pages/Attempts.jsx";
import AttemptDetail from "./pages/AttemptDetail.jsx";
import Bans from "./pages/Bans.jsx";
import BanDetail from "./pages/BanDetail.jsx";
import HwidBans from "./pages/HwidBans.jsx";
import HwidBanDetail from "./pages/HwidBanDetail.jsx";
import HwidLog from "./pages/HwidLog.jsx";
import KernelFailures from "./pages/KernelFailures.jsx";
import Sessions from "./pages/Sessions.jsx";
import SessionDetail from "./pages/SessionDetail.jsx";
import Settings from "./pages/Settings.jsx";
import Config from "./pages/Config.jsx";
import Admins from "./pages/Admins.jsx";
import AdminLogins from "./pages/AdminLogins.jsx";

function Gate({ children, super: superOnly }) {
    const { me, loading } = useAuth();
    if (loading) return <div className="page-loading">…</div>;
    if (!me)     return <Navigate to="/login" replace />;
    if (superOnly && me.role !== "super") return <Navigate to="/" replace />;
    return children;
}

export default function App() {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Gate><Layout /></Gate>}>
                    <Route index               element={<Overview />} />
                    <Route path="sessions"     element={<Sessions />} />
                    <Route path="sessions/:id" element={<SessionDetail />} />
                    <Route path="attempts"     element={<Attempts />} />
                    <Route path="attempts/:id" element={<AttemptDetail />} />
                    <Route path="bans"         element={<Bans />} />
                    <Route path="bans/:id"     element={<BanDetail />} />
                    <Route path="hwid-bans"    element={<HwidBans />} />
                    <Route path="hwid-bans/:subject" element={<HwidBanDetail />} />
                    <Route path="hwid-log"     element={<HwidLog />} />
                    <Route path="kernel-failures" element={<KernelFailures />} />
                    <Route path="settings"     element={<Settings />} />
                    <Route path="config"       element={<Config />} />
                    <Route path="admins"       element={<Gate super><Admins /></Gate>} />
                    <Route path="admin-logins" element={<Gate super><AdminLogins /></Gate>} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AuthProvider>
    );
}
